import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBuilding, faMapMarked, faMoneyBill } from '@fortawesome/free-solid-svg-icons';

const RelatedVacancyCard = ({ vacancy, company, currentLabel, utm_params }) => {
  const { utm_source, utm_campaign } = utm_params || {};
  
  // URL comum para título e botão
  const vacancyUrl = `/${currentLabel}/vacancy/${vacancy.id}-${vacancy.slug}?${
    utm_source ? 'utm_source=' + utm_source + '&' : ''
  }${
    utm_campaign ? 'utm_campaign=' + utm_campaign + '&' : ''
  }utm_medium=btn-related-vacancies`;
  
  return (
    <div 
      style={{
        backgroundColor: 'white',
        borderRadius: '8px',
        padding: '24px 32px',
        boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
        marginBottom: '10px',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%'
      }}
    >
      <div style={{ flex: 1 }}>
        <h3 style={{ 
          fontSize: '20px', 
          fontWeight: 'bold', 
          marginBottom: '12px',
          color: '#36397A'
        }}>
          <a 
            href={vacancyUrl}
            style={{
              color: '#36397A',
              textDecoration: 'none',
              transition: 'color 0.2s ease',
              cursor: 'pointer'
            }}
            onMouseOver={(e) => e.currentTarget.style.color = company?.base_hexcolor === '#ffffff' ? '#000000' : company?.base_hexcolor}
            onMouseOut={(e) => e.currentTarget.style.color = '#36397A'}
          >
            {vacancy.title}
          </a>
        </h3>
        
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '24px', alignItems: 'center' }}>
          {vacancy.department && (
            <div style={{
              display: 'flex', 
              alignItems: 'center',
              fontSize: '15px',
              color: '#667085'
            }}>
              <FontAwesomeIcon icon={faBuilding} style={{ marginRight: '10px', fontSize: '15px' }} />
              <span>{vacancy.department}</span>
            </div>
          )}
          
          {vacancy.location && (
            <div style={{
              display: 'flex', 
              alignItems: 'center',
              fontSize: '15px',
              color: '#667085'
            }}>
              <FontAwesomeIcon icon={faMapMarked} style={{ marginRight: '10px', fontSize: '15px' }} />
              <span>
                {Array.isArray(vacancy.location) 
                  ? vacancy.location.join(', ')
                  : vacancy.location}
              </span>
            </div>
          )}
          
          {vacancy.salary && (
            <div style={{
              display: 'flex', 
              alignItems: 'center',
              fontSize: '15px',
              color: '#667085'
            }}>
              <FontAwesomeIcon icon={faMoneyBill} style={{ marginRight: '10px', fontSize: '15px' }} />
              <span>R$ {vacancy.salary}</span>
            </div>
          )}
        </div>
      </div>
      
      <div style={{ marginLeft: '32px', flex: '0 0 auto' }}>
        <a
          href={vacancyUrl}
          style={{
            display: 'inline-block',
            backgroundColor: company?.base_hexcolor === '#ffffff' ? '#000000' : company?.base_hexcolor,
            color: 'white',
            padding: '12px 24px',
            borderRadius: '4px',
            textDecoration: 'none',
            textAlign: 'center',
            fontSize: '15px',
            fontWeight: 'bold',
            whiteSpace: 'nowrap'
          }}
        >
          Ver detalhes
        </a>
      </div>
    </div>
  );
};

export default RelatedVacancyCard; 